// extracted by mini-css-extract-plugin
export default {"wrapper":"HY-z","availablePromoMessagesLabel":"IY-z","promoMessageList":"JY-z","promoMessage":"KY-z","appliedPromoMessage":"LY-z","promoMessageAmount":"MY-z"};